import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getLocaleUrlPath } from 'utils';
import { PRODUCT_TYPES, CLIENT_TYPES } from 'constants/index';
import { useSelectorProps } from './useSelectorProps';
var DEFAULT_OG_IMAGE_NAME = 'rko';
export var useMetaPage = function useMetaPage() {
  var _useIntl = useIntl(),
      locale = _useIntl.locale;

  var _useSelectorProps = useSelectorProps(),
      location = _useSelectorProps.location,
      _useSelectorProps$mat = _useSelectorProps.match,
      match = _useSelectorProps$mat === void 0 ? {} : _useSelectorProps$mat;

  var _match$params = match.params,
      params = _match$params === void 0 ? {} : _match$params;
  var clientType = params.clientType;
  var isFopPage = params.page === PRODUCT_TYPES.fop;
  var isItPage = clientType === CLIENT_TYPES.it;
  var imageType = isItPage && CLIENT_TYPES.it || isFopPage && PRODUCT_TYPES.fop || DEFAULT_OG_IMAGE_NAME;
  var ogImageUrl = "".concat(process.env.APP_DEPLOY_URL).concat(process.env.APP_ASSETS_PUBLIC_PATH, "og-image-").concat(locale, "-").concat(imageType, ".png");
  return useMemo(function () {
    return [{
      property: 'og:image',
      content: ogImageUrl
    }, {
      property: 'og:type',
      content: 'website'
    }, {
      property: 'og:url',
      content: "https://minfin.com.ua".concat(getLocaleUrlPath(locale)).concat(process.env.APP_ROUTER_BASENAME).concat(location.pathname)
    }];
  }, [location.pathname, locale]);
};
export default useMetaPage;